module.exports = __webpack_public_path__ + "img/微电网.fb421b6e.png";